export default {
	all_yout_user_data_will_be_deleted_and_this_process_isnt_reversible:
		'TODOS SEUS DADOS SERÃO APAGADOS, PROCESSO IRREVERSÍVEL!',
	check_in_on_a_event: 'participar de um evento',
	commented_the_news: 'comentou na notícia',
	earned_a_certification_on_the_trail: 'recebeu um certificado na trilha',
	earned_a_certification_on_the_training: 'recebeu um certificado no treinamento',
	earned_the_badge: 'recebeu a medalha',
	evaluated_the_podcast: 'avaliou o podcast',
	evaluated_the_trail: 'avaliou a trilha',
	evaluated_the_training: 'avaliou o treinamento',
	extra_activity: 'atividade extra',
	favorited_the_podcast: 'favoritou o podcast',
	favorited_the_trail: 'favoritou a trilha',
	favorited_the_training: 'favoritou o treinamento',
	i_do_confirm_the_deletion_of_my_user_data: 'CONFIRMAR ENCERRAMENTO DE CONTA',
	liked_the_podcast: 'curtiu o podcast',
	liked_the_trail: 'curtiu a trilha',
	liked_the_training: 'curtiu o treinamento',
	liked_the_live_class: 'curtiu a aula ao vivo',
	evaluated_the_live_class: 'avaliou a aula ao vivo',
	liked_the_presential_event: 'curtiu o evento presencial',
	evaluated_the_presential_event: 'avaliou o evento presencial',
	new_sale_informed: 'nova venda informada',
	points_were_awarded_for: 'Pontos atribuídos por',
	the_file: 'O arquivo',
	the_product: 'O produto',
	the_trail: 'A trilha',
	the_training: 'O treinamento',
	the_webinar: 'O webinar',
	there_are_no_activities_at_the_moment: 'Não há atividades no momento.',
	to_confirm_enter_your_name: 'Para continuar, digite o seu nome:',
	close_account: 'Encerrar conta',
	training_finished_on_irep: 'finalizar treinamento no Programa Intel® Retail Edge',
	upgrading_to_level: 'subir para o nível',
	was_published_f: 'foi publicada',
	was_published_on_the_library: 'foi publicado na biblioteca',
	was_published: 'foi publicado',
	was_purchased: 'foi resgatado',
}
